import axios, { CancelTokenSource } from "axios"

export function getNewCancelTokenSource (
	cancelTokenSource: CancelTokenSource | undefined = undefined,
	cancelExistingTokenSource: boolean = false,
	cancelMessage: string | undefined = undefined
): CancelTokenSource {
	if (cancelTokenSource && cancelExistingTokenSource) {
		cancelTokenSource.cancel(cancelMessage)
	}

	return axios.CancelToken.source()
}

/**
 * Whether a failed request failed because it was cancelled, rather than because anything
 * went wrong. A superseded query cancels the one before it, so its caller has nothing to report.
 */
export function isCancelledRequest (error: unknown): boolean {
	return axios.isCancel(error)
}
